import { Checklist as ChecklistIcon } from 'components/icons';
import { Tooltip } from 'components/ui/tooltip';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';

// Components
import PermissionButton from 'components/buttons/PermissionButton';
import { useBulkDebtNotesModal } from 'components/modals/invoices/BulkDebtNotesModal';

// Store
import { setBulkDebtReminderInvoices } from 'store/reducers/invoices';

// Types
import { InvoiceDataListItem } from 'types/invoices';

interface Props {
    invoices: InvoiceDataListItem[];
}

export const BulkSelectButton = ({ invoices }: Props) => {
    const { formatMessage } = useIntl();
    const dispatch = useDispatch();
    const { openBulkDebtNotesModal } = useBulkDebtNotesModal(invoices);

    const handleBulkSelect = () => {
        dispatch(setBulkDebtReminderInvoices(invoices));
        openBulkDebtNotesModal();
    };

    const label = formatMessage({ id: 'invoices.tooltips.bulk-select-filtered-invoices' });

    return (
        <div className="flex flex-row justify-end gap-2">
            {/* The span carries the tooltip: a disabled button fires no pointer events. */}
            <Tooltip content={label} side="bottom">
                <span>
                    <PermissionButton
                        permissions={['UPDATE.INVOICES.BILLING_NOTES']}
                        variant="outlined"
                        size="small"
                        className="min-w-0 px-2"
                        aria-label={label}
                        disabled={invoices.length === 0}
                        onClick={handleBulkSelect}
                    >
                        <ChecklistIcon className="text-[20px]" />
                    </PermissionButton>
                </span>
            </Tooltip>
        </div>
    );
};
